import { ReactElement } from 'react';
import { EContainerIconSize, EIconSize } from 'utils/constants/app/ui';
import { NOTIFICATION_SUPPORTING_SPORTS } from 'utils/constants/sportsbook/notificationSupportSports';
import { NotificationIconContent } from './content';
import './index.less';

export type TNotificationIconProps = {
  game: { id: number; start_ts: number };
  currentSport: string;
  size?: EIconSize._16 | EIconSize._20;
  iconContainerSize?:
    | EContainerIconSize.SMALL
    | EContainerIconSize.MIDDLE
    | EContainerIconSize.LARGE
    | 0;
};

export const NotificationIcon = ({
  currentSport,
  game,
  size,
  iconContainerSize
}: TNotificationIconProps): ReactElement | null => {
  return NOTIFICATION_SUPPORTING_SPORTS.includes(currentSport) ? (
    <NotificationIconContent
      currentSport={currentSport}
      game={game}
      size={size}
      iconContainerSize={iconContainerSize}
    />
  ) : null;
};
